import Logger from '../lib/logger';
import { money } from '../lib/util.functions';

export default class ConfiguratorSideCart {
  NAME = 'ConfiguratorSideCart';
  #dom
  #body
  #placeholderUrl
  #subtotalDom
  #continueBtns
  #toggleBtns
  messageBtns
  #count = 0;
  #countDom
  #containers = {
    container: undefined,
    gifts: undefined,
    card: undefined
  }
  #templateDoc
  #total = '$0.00';
  defaultMessage = '* add a message';
  bundleType = 'custom';
  #timeThreshhold = 100;
  #swipeThreshhold = 50;
  #swipeStart = { x: 0, y: 0 };
  #swipeTimeBegin = 0;

  set total(value) {
    this.#total = money(value);
    this.#subtotalDom.textContent = this.#total;
    switch (this.step) {
      case 1:
        this.#continueBtns.forEach((btn) => {
          btn.dataset.disabled = !this.hasContainer;
        }); 
        break;

      case 2:
        this.#continueBtns.forEach((btn) => {
          btn.dataset.disabled = !(this.hasContainer && (this.hasGifts || this.bundleType !== 'custom'));
        });
        break;

      case 3:
        this.#continueBtns.forEach((btn) => {
          btn.dataset.disabled = !(this.hasContainer && (this.hasGifts || this.bundleType !== 'custom') && this.hasCard && this.hasMessage);
        });
        if (this.hasCard && !this.hasMessage) {
          this.#continueBtns.forEach((btn) => {
            btn.dataset.show = 'false';
          });
          this.messageBtns.forEach((btn) => {
            btn.dataset.show = 'true';
          });
        } else {
          this.#continueBtns.forEach((btn) => {
            btn.dataset.show = 'true';
          });
          this.messageBtns.forEach((btn) => {
            btn.dataset.show = 'false';
          });
        }
        break;
    
      default:
        break;
    }
  }

  get total() {
    return this.#total;
  }

  set count(value) {
    this.#count = value;
    this.#countDom.dataset.count = this.#count;
  }

  get count() {
    return this.#count;
  }

  get hasContainer() {
    return !!this.#containers.container.children[1]
  }

  get hasGifts() {
    return !!this.#containers.gifts.children.length
  }

  get hasCard() {
    return !!this.#containers.card.children.length
  }

  get hasMessage() {
    return this.#containers.card.querySelector('[data-content-1]')?.dataset.content !== this.defaultMessage
  }

  constructor(step) {
    Logger.info(`${this.NAME} > constructor`);
    let template = `
      <div class="configurator-side-cart__item-container__item" data-product-variant-id="">
        <div class="configurator-side-cart__item-container__item__image" data-image-wrap>
          <img src="" width="52" height="52" loading="lazy">
          <div class="configurator-side-cart__item-container__item__quantity" data-quantity="1"></div>
        </div>
        <div class="configurator-side-cart__item-container__item__content">
          <div class="configurator-side-cart__item-container__item__content__title" data-title>
          </div>

          <div class="configurator-side-cart__item-container__item__content__price-row">
            <div class="configurator-side-cart__item-container__item__content__price" data-price>
              $0.00
            </div>

            <button class="configurator-side-cart__item-container__item__content__btn" data-icon="trash" data-variant-id="">
            </button>
          </div>

          <div class="configurator-side-cart__item-container__item__content__other-content">
            <span data-content-1></span>
            <span data-content-2></span>
            <span data-content-3></span>
          </div>
        </div>
      </div>
    `;
    this.step = step;
    this.#templateDoc = new DOMParser().parseFromString(template, "text/html");
    this.#dom = document.querySelector('[data-configurator-side-cart]');
    this.#placeholderUrl =  this.#dom.dataset.placeholderUrl
    this.#body = this.#dom.querySelector('[data-body]');
    this.#containers.container = this.#dom.querySelector('[data-item-container-type="container"] [data-items]');
    this.#containers.gifts = this.#dom.querySelector('[data-item-container-type="gifts"] [data-items]');
    this.#containers.card = this.#dom.querySelector('[data-item-container-type="card"] [data-items]');
    this.#subtotalDom = this.#dom.querySelector('[data-subtotal-price]');
    this.#continueBtns = document.querySelectorAll('[data-continue-btn]');
    this.messageBtns = document.querySelectorAll('[data-message-btn]');
    this.#countDom = this.#dom.querySelector('[data-count]');
    this.#toggleBtns = this.#dom.querySelectorAll('.theme-button--small');
    this.#toggleBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.#dom.dataset.open = !(this.#dom.dataset.open === 'true');
      })
    });
    this.#dom.firstElementChild.addEventListener('touchstart', (e) => this.#onTouchStart(e));
    this.#dom.firstElementChild.addEventListener('touchend', (e) => this.#onTouchEnd(e));
  }

  addItem(type, { variantId, title, price, quantity, image, icon, extraContent1, extraContent2, extraContent3, btnCallBack }) {
    /* console.log(type, { variantId, title, price, quantity, image, icon, extraContent1, extraContent2, btnCallBack }); */
    const itemDom = document.createElement('DIV');
    itemDom.innerHTML = this.#templateDoc.documentElement.innerHTML;
    const btn = itemDom.querySelector('button');
    if (variantId) {
      itemDom.dataset.productVariantId = variantId;
      btn.dataset.variantId = variantId;
    }
    if (icon) btn.dataset.icon = icon;
    if (btnCallBack) btn.addEventListener('click', btnCallBack);
    if (image) {
      itemDom.querySelector('img').src = image;
    } else {
      itemDom.querySelector('img').src = this.#placeholderUrl;
    }
    if (title) itemDom.querySelector('[data-title]').textContent = title;
    if (price) itemDom.querySelector('[data-price]').textContent = money(price);
    if (quantity) itemDom.querySelector('[data-quantity]').dataset.quantity = quantity;
    if (type === 'card' && !extraContent1) itemDom.querySelector('[data-content-1]').dataset.content = this.defaultMessage;
    if (extraContent1) itemDom.querySelector('[data-content-1]').dataset.content = extraContent1;
    if (extraContent2) itemDom.querySelector('[data-content-2]').dataset.content = extraContent2;
    if (extraContent3) itemDom.querySelector('[data-content-3]').dataset.content = extraContent3;
    this.#containers[type].appendChild(itemDom);
  }

  updateContainer({ variantId, title, price, quantity, image, icon, extraContent1, extraContent2, extraContent3 }) {
    const itemDom = this.#containers.container.children[1];
    const btn = itemDom.querySelector('button');
    if (variantId) btn.dataset.variantId = variantId;
    if (icon) btn.dataset.icon = icon;
    if (image) itemDom.querySelector('img').src = image;
    if (title) itemDom.querySelector('[data-title]').textContent = title;
    if (price !== undefined) itemDom.querySelector('[data-price]').textContent = money(price);
    if (quantity) itemDom.querySelector('[data-quantity]').dataset.quantity = quantity;
    if (extraContent1) itemDom.querySelector('[data-content-1]').dataset.content = extraContent1;
    if (extraContent2) itemDom.querySelector('[data-content-2]').dataset.content = extraContent2;
    if (extraContent3) itemDom.querySelector('[data-content-3]').dataset.content = extraContent3;
  }

  updateCard({ variantId, title, price, quantity, image, icon, extraContent1, extraContent2 }) {
    const itemDom = this.#containers.card.children[0];
    const btn = itemDom.querySelector('button');
    if (variantId) btn.dataset.variantId = variantId;
    if (icon) btn.dataset.icon = icon;
    if (image) itemDom.querySelector('img').src = image;
    if (title) itemDom.querySelector('[data-title]').textContent = title;
    if (price !== undefined) itemDom.querySelector('[data-price]').textContent = money(price);
    if (quantity) itemDom.querySelector('[data-quantity]').dataset.quantity = quantity;
    if (extraContent1) itemDom.querySelector('[data-content-1]').dataset.content = extraContent1;
    if (extraContent2) itemDom.querySelector('[data-content-2]').dataset.content = extraContent2;
  }

  updateGift(variantId, { title, price, quantity, image, icon }) {
    const itemDom = this.#containers.gifts.querySelector(`[data-product-variant-id="${variantId}"]`);
    const btn = itemDom.querySelector('button');
    if (icon) btn.dataset.icon = icon;
    if (image) itemDom.querySelector('img').src = image;
    if (title) itemDom.querySelector('[data-title]').textContent = title;
    if (price !== undefined) itemDom.querySelector('[data-price]').textContent = money(price);
    if (quantity) itemDom.querySelector('[data-quantity]').dataset.quantity = quantity;
  }

  removeContainer() {
    let itemDom = this.#containers.container.children[1];
    let btn = itemDom.querySelector('button');
    itemDom.remove();
    btn = null;
    itemDom = null;
  }

  removeCard() {
    let itemDom = this.#containers.card.children[0];
    let btn = itemDom.querySelector('button');
    itemDom.remove();
    btn = null;
    itemDom = null;
  }

  removeGift(variantId) {
    let itemDom = this.#containers.gifts.querySelector(`[data-product-variant-id="${variantId}"]`);
    let btn = itemDom.querySelector('button');
    itemDom.remove();
    btn = null;
    itemDom = null;
  }

  triggerContinueButton() {
    this.#continueBtns[0].click();
  }

  show() {
    this.#body.dataset.show = 'true';
  }

  #onTouchStart(e) {
    if (window.innerWidth < 960) {
      this.#swipeStart = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      this.#swipeTimeBegin = e.timeStamp;
    }
  }

  #onTouchEnd(e) {
    if (window.innerWidth < 960 && 
      (this.#dom.dataset.open === 'false' || (e.target !== this.#body && this.#body.querySelector(`.${e.target.className}`) === null))) 
    {
      const amount = this.#swipeStart.y - e.changedTouches[0].clientY;
      const time = e.timeStamp - this.#swipeTimeBegin;
      if (time > this.#timeThreshhold && Math.abs(amount) >= this.#swipeThreshhold) {
        this.#swipeStart = { x: 0, y: 0 };
        this.#swipeTimeBegin = 0;
        this.#dom.dataset.open = !(this.#dom.dataset.open === 'true');
      }
    }
  }
}